<template>
  <div>
    <PassForm :submit="submitPressed" :isEditing="false" />
  </div>
</template>

<script>
import PassForm from './common/PassForm';
import api from '../api';

export default {
  components: {
    PassForm
  },
  data() {
    return {

    };    
  },
  methods: {
    async submitPressed(data) {
      console.log(data)
      const passId = await api.uploadPass(data);
      return passId;
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/CreatePass.vue